export default __webpack_public_path__ + "static/media/linkedIn-basic.ca60fc4e.svg";